module.exports = __webpack_public_path__ + "static/coffee-story-e4c9915db39c5a523b3f570a2d085981.jpg";